import { template } from "@ember/template-compiler";
export default template(`
  <div class="cost-estimator-footer__estimate-amount">
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvYmlsbGluZy1jb21tb24vcGFja2FnZS9zcmMvY29tcG9uZW50cy9iaWxsaW5nL2Nvc3QtZXN0aW1hdG9yL2Ftb3VudC5nanMiXSwic291cmNlc0NvbnRlbnQiOlsiPHRlbXBsYXRlPlxuICA8ZGl2IGNsYXNzPVwiY29zdC1lc3RpbWF0b3ItZm9vdGVyX19lc3RpbWF0ZS1hbW91bnRcIj5cbiAgICB7e3lpZWxkfX1cbiAgPC9kaXY-XG48L3RlbXBsYXRlPlxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxlQUFBLFNBQVUsQ0FBQTs7OztBQUlWLENBQUEsRUFBQTtJQUFBO1FBQUEsT0FBQSxLQUFBLFNBQUEsQ0FBQSxFQUFXO0lBQUQ7QUFBQSxHQUFDIn0